import { render, staticRenderFns } from "./UploadBankCard.vue?vue&type=template&id=d1377230&scoped=true"
import script from "./UploadBankCard.vue?vue&type=script&lang=js"
export * from "./UploadBankCard.vue?vue&type=script&lang=js"
import style0 from "./UploadBankCard.vue?vue&type=style&index=0&id=d1377230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1377230",
  null
  
)

export default component.exports